import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpsertCompanyComponent } from '../upsert-company.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared.module';
import { Observable } from 'rxjs';
import { TranslocoModule } from '@ngneat/transloco';
import { Util } from '../../../models/util';
import { Company } from '../../../models/company/company';

@Component({
  selector: 'psc-edit-company',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SharedModule, TranslocoModule],
  templateUrl: '../upsert-company.component.html',
})
export class EditCompanyComponent extends UpsertCompanyComponent implements OnInit {
  @Input() company: Company;

  override ngOnInit() {
    super.ngOnInit();
    this.formGroup.patchValue(this.company);
    this.formGroup.addControl('companyId', new FormControl(this.company.companyId));
    this.formGroup.addControl('visibility', new FormControl(this.company.visibility));
    const file = new File([Util.b64toBlob(this.company.logo)], 'logo.png');
    this.formGroup.controls['logo'].setValue([file]);
    this.formGroup.updateValueAndValidity();
    this.setInitialCountry(this.formGroup.get('country')?.value);
  }

  protected saveToApi(company: Company, logo: File): Observable<Company> {
    return this.owner ? this.companyService.updateMyCompany(company, logo) : this.companyService.updateCompany(company, logo);
  }
}
